import React, { Component } from 'react'
import { Form, FormField, LinkButton, Panel, Messager, TextBox, ComboBox } from 'rc-easyui';
import { getCookie, getAccessToken } from '../../../helpers/cookieHelper';
import { API_URL } from "../../../constants";

import { Button } from 'reactstrap';
import { isEmpty } from "../../../helpers";
import { autoDissaperAction } from "../../../helpers/index";






const axios = require("axios");
class CreateProject extends Component {
  constructor(props) {
    super(props)

    this.state = {
      isLoading: false,
      users:[]
    }
  }

  componentDidMount(){
    this.getUsers()
  }

  getUsers = async () => {
    let token = getCookie("access_token");
    let tokenType = getCookie("token_type");
    let apiUrl = `${API_URL}api/allactiveusers`;
    let headersConfig = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `${tokenType} ${token}`,
      },
    };

        if (token != null) {
          //Access Token Available
          this.setState({
            isLoading: true,
          });
          axios
            .get(apiUrl, headersConfig)
            .then((response) => {

              if (response.status === 200) {
                if (response.data.status) {
                  this.setState({
                    users:response.data.object,
                    isLoading:false
                  })
                } else {
                  this.setState({
                    isLoading: false,
                  });
                }
                // this.props.formClear();
              } else {
                this.setState({
                  isLoading: false,
                });
              }
            })
            .catch((error) => {
              this.setState({
                isLoading: false,
              });
              this.messager.alert({
                title: "Error",
                msg: "Internal Server Error",
                reload: false,
              });
              var response = error["response"];
              if (response !== undefined) {
                if (response.status === 400) {
                  var message = "";
                  response.data.errors.forEach((row, i) => {
                    message +=
                      "<p style='margin-bottom:3px;'>" +
                      row.field.toUpperCase() +
                      " " +
                      row.defaultMessage +
                      "</p>";
                  });
                  this.messager.alert({
                    title: "Error",
                    msg: message,
                    reload: false,
                  }); // Backend Validation Error ie.400
                } else {
                  this.messager.alert({
                    title: "Error",
                    msg: "UnCaught Error",
                    reload: false,
                  }); // Uncaught Backend Error ie.500 eyc.
                }
              } else {
                this.messager.alert({
                  title: "Error",
                  msg: "Internal Server Error",
                  reload: false,
                }); // Caused due to syntax error in front end
              }
            });
        } else {
          //Access Token Expired.
          //Generate new Access Token using Refresh Token.
          const resp = await getAccessToken();
          if (resp) {
            this.getUsers();
          }
        }
  }





  handleSave = async () => {
    let token = getCookie("access_token");
    let tokenType = getCookie("token_type");
    let form = Object.assign({}, this.props.project)
    let apiUrl = `${API_URL}api/saveprojectinfo`;
    let headersConfig = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `${tokenType} ${token}`,
      },
    };
    this.props.innerRef.current.validate(async (errors) => {
      if (isEmpty(errors)) {
        //No Form Validation Error
        if (token != null) {
          //Access Token Available
          this.setState({
            isLoading: true,
          });
          axios
            .post(apiUrl, form, headersConfig)
            .then((response) => {

              if (response.status === 200) {
                this.setState({
                  isLoading: false,
                });
                if (response.data.status) {
                  this.messager.alert({
                    title: "Success",
                    msg: response.data.message,
                    icon: "info",
                    reload: true,
                    buttons: [
                      {
                        text: "ok",
                        onClick: () => {
                          window.location.reload();
                        },
                      },
                    ],
                  }); // ticket detail  Saved Successfully ie. 200
                  autoDissaperAction();
                } else {
                  this.messager.alert({
                    title: "Error",
                    msg: response.data.message,
                  });
                }
                // this.props.formClear();
              } else {
                this.messager.alert({
                  title: "Error",
                  msg: "Uncaught Error",
                  reload: false,
                });
              }
            })
            .catch((error) => {
              this.setState({
                isLoading: false,
              });
              this.messager.alert({
                title: "Error",
                msg: "Internal Server Error",
                reload: false,
              });
              var response = error["response"];
              if (response !== undefined) {
                if (response.status === 400) {
                  var message = "";
                  response.data.errors.forEach((row, i) => {
                    message +=
                      "<p style='margin-bottom:3px;'>" +
                      row.field.toUpperCase() +
                      " " +
                      row.defaultMessage +
                      "</p>";
                  });
                  this.messager.alert({
                    title: "Error",
                    msg: message,
                    reload: false,
                  }); // Backend Validation Error ie.400
                } else {
                  this.messager.alert({
                    title: "Error",
                    msg: "UnCaught Error",
                    reload: false,
                  }); // Uncaught Backend Error ie.500 eyc.
                }
              } else {
                this.messager.alert({
                  title: "Error",
                  msg: "Internal Server Error",
                  reload: false,
                }); // Caused due to syntax error in front end
              }
            });
        } else {
          //Access Token Expired.
          //Generate new Access Token using Refresh Token.
          const resp = await getAccessToken();
          if (resp) {
            this.handleSave();
          }
        }
      } else {
        alert("Front End Form Validaion ");
      }
    });

  }


  handleUpdate = () => {
    let token = getCookie("access_token");
    let tokenType = getCookie("token_type");
    let form = Object.assign({}, this.props.project);
    let apiUrl = `${API_URL}api/saveprojectinfo`;
    let headerConfig = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `${tokenType} ${token}`,
      },
    };
    this.props.innerRef.current.validate(async (errors) => {
      if (isEmpty(errors)) {
        //No Form Validation Error
        if (token != null) {
          //Access Token Available
          this.setState({
            isLoading: true,
          });
          //console.log(form);
          axios
            .put(apiUrl, form, headerConfig)
            .then((response) => {
              if (response.status === 200) {
                this.setState({
                  isLoading: false,
                });
                if (response.data.status) {

                  // this.messager.alert({
                  //   title: "Success",
                  //   msg: response.data.message,
                  //   reload: true,
                  // }); // script detail  Saved Successfully ie. 200
                  this.messager.alert({
                    title: "Success",
                    msg: response.data.message,
                    icon: "info",
                    reload: true,
                    buttons: [
                      {
                        text: "ok",
                        onClick: () => {
                          window.location.reload();
                        },
                      },
                    ],
                  }); // script detail  Saved Successfully ie. 200
                  autoDissaperAction();

                } else {
                  this.messager.alert({
                    title: "Error",
                    msg: response.data.message,
                  });
                }
              } else {
                this.messager.alert({
                  title: "Error",
                  msg: "Uncaught Error",
                  reload: false,
                });
              }
            })
            .catch((error) => {
              //console.log("error",error);
              this.setState({
                isLoading: false,
              });
              var response = error["response"];
              if (response !== undefined) {
                if (response.status === 400) {
                  var message = "";
                  response.data.errors.forEach((row, i) => {
                    message +=
                      "<p style='margin-bottom:3px;'>" +
                      row.field.toUpperCase() +
                      " " +
                      row.defaultMessage +
                      "</p>";
                  });
                  //console.log(message);
                  this.messager.alert({
                    title: "Error",
                    msg: message,
                    reload: false,
                  }); // Backend Validation Error ie.400
                } else {
                  this.messager.alert({
                    title: "Error",
                    msg: "UnCaught Error",
                    reload: false,
                  }); // Uncaught Backend Error ie.500 eyc.
                }
              } else {
                this.messager.alert({
                  title: "Error",
                  msg: "Internal Server Error",
                  reload: false,
                }); // Caused due to syntax error in front end
              }
            });
        } else {
          //Access Token Expired.
          //Generate new Access Token using Refresh Token.
          const resp = await getAccessToken();
          if (resp) {
            this.handleUpdate();
          }
        }
      } else {
        alert("Front End Form Validaion ");
      }
    })
  }








  render() {
    const { project,
      handleInput,
      operation,
      rules,

    } = this.props;
    const { isLoading } = this.state;
    return (
      <div>

        <Panel title='Project Info' bodyStyle={{ padding: 20 }}>
          <Messager
            ref={(ref) => (this.messager = ref)}
            showHeader={false}
            borderType='none'
            content={({ title, msg, buttons, reload }) => (
              <div className='alert-content'>
                <h3>{title}</h3>
                <div
                  style={{ marginBottom: 5 }}
                  dangerouslySetInnerHTML={{ __html: msg }}
                ></div>
                <div className='m-buttons'>
                  {buttons.map((button, index) => (
                    <LinkButton
                      key={index}
                      text={button.text}
                      onClick={() => {
                        this.messager.close(button);
                        if (reload) {
                          window.location.reload();
                        }
                      }}
                    />
                  ))}
                </div>
              </div>
            )}
          />
          <div
            className='loadingmodel'
            style={{ display: isLoading ? "block" : "none" }}
          ></div>

          <Form
            ref={this.props.innerRef}
            style={{ maxWidth: 500 }}
            model={project}
            labelWidth={400}
            labelAlign="left"
            labelPosition='top'
            onChange={handleInput}
            rules={rules}>
            <div>
            <FormField name="projectName" label="Project Name" >
                <TextBox
                  value={project.projectName}
                ></TextBox>
              </FormField>

              <FormField name="projectManagerId" label="Project Manager Name">
                {/* <TextBox
                  value={project.projectManagerId}
                ></TextBox> */}
                <ComboBox
                data={this.state.users}
                value={project.projectManagerId}
                valueField="id"
                textField="fullname"
                ></ComboBox>
              </FormField>



            </div>


            <div className='text-center'>
              <Button
                color='primary'
                disabled={isLoading ? true : false}
                onClick={
                  operation === "Add" ? this.handleSave : this.handleUpdate
                }
                style={{ marginRight: 20 }}
              >
                {operation === "Add" ? "Save" : "Update"}
              </Button>
              <Button color='danger' onClick={this.props.formClear}>
                Cancel
              </Button>
            </div>
          </Form>
        </Panel>
      </div>
    )
  }
}
export default React.forwardRef((props, ref) => (
  <CreateProject innerRef={ref} {...props} />
))
